import {app} from '../app';
import {ErrorService} from "../services/ErrorService";

export class ErrorController {

    private http:ng.IHttpService;
    private timeout:ng.ITimeoutService;
    private window:ng.IWindowService;
    private errorService:ErrorService;

    static $inject = ['$http', '$timeout', '$window', 'ErrorService'];

    constructor($http:ng.IHttpService, $timeout, $window, ErrorService:ErrorService) {
        this.http         = $http;
        this.timeout      = $timeout;
        this.window       = $window;
        this.errorService = ErrorService;
    }

    onLostConnectionTryAgain() {
        this.timeout(() => {
            const response = this.errorService.getHttpErrorResponse();
            if (response) {
                this.http(response.config).then(() => {
                    this.errorService.runResumeConnectionCallbacks();
                });
            }
        }, 500);
    }
}

app.controller('ErrorController', ErrorController);
